import { get } from '@partment/client'
import { BaseResponse, IPersona } from '@partment/types'
import { v3Path } from './versionedPath'

export const getPersonas = async (): Promise<
  BaseResponse<{ personas: ReadonlyArray<IPersona> }>
> => {
  return get(v3Path('accounts/auth/personas/assigned/')) as unknown as Promise<
    BaseResponse<{ personas: ReadonlyArray<IPersona> }>
  >
}
